<template>
    <div data-testid="financialclose_component_fileuploadsriskmanagement__root">
      <div v-for="(item, i) in files" :key="i" class="hoverable" :data-testid="`financialclose_component_fileuploadsriskmanagement__file-row-${i}`">
        <div class="px-2 py-1" data-testid="financialclose_component_fileuploadsriskmanagement__file-panel">
          <div class="d-flex align-center" data-testid="financialclose_component_fileuploadsriskmanagement__file-header">
            <div class="font-weight-bold" data-testid="financialclose_component_fileuploadsriskmanagement__file-title">
              <span class="mr-2" data-testid="financialclose_component_fileuploadsriskmanagement__file-serial">{{ i + 1 }}.</span>
              <span data-testid="financialclose_component_fileuploadsriskmanagement__file-name">{{ item.name }}</span>
              <v-icon color="success" class="ml-2"
                v-if="(filevalues[item._id] || {}).processed === 1" data-testid="financialclose_component_fileuploadsriskmanagement__file-status-success">mdi-check-circle</v-icon>
              <v-icon color="info" class="ml-2" v-else data-testid="financialclose_component_fileuploadsriskmanagement__file-status-pending">mdi-timer-sand</v-icon>
            </div>
            <v-spacer></v-spacer>
            <div v-if="fileproerr[item._id]" class="ml-2" data-testid="financialclose_component_fileuploadsriskmanagement__file-error">
              <span class="error--text">{{ fileproerr[item._id] || "Unknown Error" }}</span>
            </div>
            <span v-if="filevalues[item._id]" @click="$nova.downloadFile((filevalues[item._id] || {})._id)"
              class="mx-2 cursor-pointer blue--text text--darken-2 caption" data-testid="financialclose_component_fileuploadsriskmanagement__file-download">
              <v-icon class="mr-1 blue--text text--darken-2">mdi-file</v-icon>
              {{ filevalues[item._id].uploadname }}
            </span>
            <div v-if="fileprostage[item._id] === 1 && filecount" class="ml-2" data-testid="financialclose_component_fileuploadsriskmanagement__file-status-validating">
              <v-chip color="info" :value="true" label> <span>Validating</span> </v-chip>
            </div>
            <div v-else-if="(filevalues[item._id] || {}).processed === 0" class="ml-2" data-testid="financialclose_component_fileuploadsriskmanagement__file-status-processing">
              <v-chip label color="warning" :value="true">
                <span>Processing</span>
              </v-chip>
            </div>
            <div v-else-if="fileprostage[item._id] === 2 && filecount" class="ml-2" data-testid="financialclose_component_fileuploadsriskmanagement__file-status-uploading">
              <v-chip label color="info" :value="true"> <span>Uploading</span> </v-chip>
            </div>
            <lb-file v-if="((filevalues[item._id] || {}).processed !== 0 && ($nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add') || $nova.hasRight(right, 'delete'))) && editable" v-model="filesdataPros[item._id]" label=""
              class="py-0 my-0 ml-2" :drag="false" hidedetails :loading="[1, 2].indexOf(fileprostage[item._id]) > -1"
              :loadingpercent="(Number(fileuppercent[item._id]) || 0) + filecount * 0" :displayname="false"
              accept=".xlsx,.xls,.xlsm,.xlsb,.csv" @change="FileProcess(item._id, item.columns)"
              data-testid="financialclose_component_fileuploadsriskmanagement__file-upload-btn"></lb-file>
          </div>
          <div data-testid="financialclose_component_fileuploadsriskmanagement__file-columns-panel">
            <div class="grey--text text--darken-1 mb-1">Required columns:</div>
  
            <div v-if="(fileconfig[item._id] || {}).columnmap" data-testid="financialclose_component_fileuploadsriskmanagement__file-columns-list">
              <v-chip color="lightpurple" label class="caccounting--text mr-3 mb-2" v-for="(item, i) in (fileconfig[item._id] || {}).columnmap || []" :key="i" :data-testid="`financialclose_component_fileuploadsriskmanagement__file-column-chip-${i}`"><span>{{ item[1] || "Unknown" }}</span></v-chip>
            </div>
  
            <div v-else data-testid="financialclose_component_fileuploadsriskmanagement__file-columns-list-fallback">
              <v-chip color="lightpurple" label class="caccounting--text mr-3 mb-2" v-for="(item, i) in files[i].columns" :key="i" :data-testid="`financialclose_component_fileuploadsriskmanagement__file-column-chip-fallback-${i}`"><span>{{ item.name }}</span></v-chip>
            </div>
          </div>
        </div>
        <v-divider class="" data-testid="financialclose_component_fileuploadsriskmanagement__file-divider"></v-divider>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      files: {
        type: Array,
        required: true,
      },
      filevalues: {
        type: Object,
        required: true,
      },
      fileproerr: {
        type: Object,
        required: true,
      },
      fileprostage: {
        type: Object,
        required: true,
      },
      fileuppercent: {
        type: Object,
        required: true,
      },
      storepath: {
        type: String,
        required: true,
      },
      // filecount: {
      //   type: Number,
      //   required: true,
      // },
      filesdataPros: {
        type: Object,
        required: true,
      },
      fileconfig: {
        type: Object,
        required: true,
      },
      editable: {
        type: Boolean,
        default: false,
      },
      right:{
        type: String,
        default: '',
      }
    },
    data() {
      return {
        filecount: 0,
        fileuploadpercent: {},
        file:{}
      };
    },
    methods: {
      FileProcess(id, columns) {
        if (this.filesdataPros[id] && (this.fileprostage[id] === 0 || this.fileprostage[id] === undefined)) {
          let success = false;
          this.fileprostage[id] = 1;
          this.filecount++;
          this.fileproerr[id] = "";
          this.file = this.filesdataPros[id] || {};
          let config = this.fileconfig[id] || {};
          let columArr = [];
          for (const i of columns) {
            columArr.push([i.name, i.name]);
          }
          // config.columncount = ((config?.columnmap?.length || 0) + (config?.ignoredcolumns?.length || 0)) || 0;
          this.$emit('startloading');
          this.$nova
            .processConserveFile(this.file, config, columArr)
            .then(() => {
              this.fileprostage[id] = 2;
              this.filecount++;
              return this.$nova.uploadFile(this.axios, this.file, {
                progressfunction: (e) => {
                  let p = (e.loaded * 100) / e.total;
                  this.fileuploadpercent[id] = p.toFixed(0);
                  this.filecount++;
                },
              });
            })
            .then((dt) => {
              if (dt.data.status === "success") {
                this.fileUpDetil = dt.data.data[0];
  
                return this.axios.post(
                  this.storepath,
                  {
                    data: { upload: this.fileUpDetil._id, file: id },
                  }
                )
              } else throw new Error("Unable to upload file");
            })
            .then((dt) => {
              if (dt.data.status === "success") {
                 success = true;
                this.fileUploadedDetilas = dt.data.data;
                this.$emit("storedData", {"stored":this.fileUploadedDetilas,"uploaded":this.file})
              } else throw new Error(dt.data.message || "Error storing file");
            })
            .catch((err) => {
              this.fileproerr[id] = err.message || err || "Unknown error!";
              console.log(err);
            })
            .finally(() => {
              this.filesdataPros[id] = null;
              this.fileprostage[id] = 0;
              this.filecount++;
              this.file = {}
              this.loading  = (success) ? this.$emit('startloading') : this.$emit('stoploading');
              // this.$emit('stoploading');
            });
        }
      },
    },
  };
  </script>